import $ from 'jquery'
import Swiper from 'swiper/bundle'

const initializeBlock = function ($block) {
  const wrapper = $block.find('.responsive-views-block__slider')

  new Swiper(wrapper[0], {
    loop: true,
    autoHeight: true,
    navigation: {
      nextEl: '.responsive-views-block__nav--next',
      prevEl: '.responsive-views-block__nav--prev',
    },
  })
}

$('.responsive-views-block').each(function () {
  initializeBlock($(this))
})

if (window.acf) {
  window.acf.addAction(
    'render_block_preview/type=vn-responsive-views',
    initializeBlock
  )
}
